module.exports = __webpack_public_path__ + "static/media/marinex_arrow_left_blue.6c518853.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/marinex_arrow_left_blue.svg
// module id = 291
// module chunks = 0